import React from 'react';
import LocationTemplate from './LocationTemplate';

const LewistonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Lewiston Woodville"
      stateName="North Carolina"
      countyName="Bertie"
      zipCodes={["27849"]}
      latitude={36.1282}
      longitude={-77.1869}
      population={548}
      historicalFact="Incorporated in 1951, formed by merging the communities of Lewiston and Woodville."
      nearbyTowns={[
        "Windsor, NC",
        "Aulander, NC",
        "Kelford, NC",
        "Scotland Neck, NC",
        "Oak City, NC",
        "Robersonville, NC",
        "Colerain, NC",
        "Hamilton, NC"
      ]}
    />
  );
};

export default LewistonPage;